"use strict"

import { Data } from '@/lib/core/components/data/data'
import { irParaTerrenoButton } from '@/lib/core/terrenos/terrenosFormShared'
import { TerrenosDM } from '@/lib/core/terrenos/terrenos'
import { LotesDM } from '@/lib/core/public/lotes'
import { IPTUsDM, IPTU } from '@/lib/core/public/iptus'
import { ITBIsDM, ITBI } from '@/lib/core/public/itbis'
// Form
import { FieldText } from '@/lib/core/components/data/form/FieldText'
import { multilines } from '@/lib/core/components/data/form/multilines'
import { FieldMap } from '@/lib/core/components/data/form/FieldMap'
// Lib
import * as jsf from '@/lib/js_functions'

export class TerrenosLotesForm extends Data {
  #terrenos
  #lotes
  #iptus
  #itbis
  constructor({ form, updateStore, Logic, component }) {
    super({ form, module: 'data', dataId: 'terrenos_lotes', updateStore, Logic, component, originClass: TerrenosLotesForm })
  }
  build = async ({ register, fields, companySpecialFields, notStart }) => {
    const specialFields = {
      irParaTerrenoButton: irParaTerrenoButton,
      negociacoes: NegociacoesMultilines,
      ['negociacoes.valor']: NegociacoesValorText,
      ['negociacoes.valorporm2']: NegociacoesValorporm2Text,
      poligono: LotesFieldMap,
    }
    Object.assign(specialFields, companySpecialFields)
    super.form.build({ register, fields, specialFields })
    notStart || await this.start({ register })
    return this
  }
  async start({ register }) {
    const firstEnter = register.firstEnter
    register.firstEnter = ''
    const hasTerrenoAndLote = register.terreno && register.lote
    const isNew = !register._id
    if (hasTerrenoAndLote) {
      await this.#getTerrenosInfos({ register })
      const loteLine = this.#getLoteLineOfTerreno({ register })
      this.#fillTerrenoInfos({ register, loteLine })
      if (firstEnter) {
        await this.getInfos({ register })
        this.form?.negociacoes.fillInfos({ register, data: this.#terrenos.form.register.ofertas[0].data })
        this.#fillPublicInfos({ register })
      }
    }
    if (isNew) { super.form?.poligono?.centerMap() }
  }
  async getInfos({ register }) {
    await this.#getLoteInfos({ register })
    await this.#getIPTUInfos()
    await this.#getITBIInfos()
    return { iptu: this.#iptus, itbi: this.#itbis }
  }
    async #getTerrenosInfos({ register }) { // eslint-disable-line
    this.#terrenos = new TerrenosDM({})
    await this.#terrenos
      .form
      .readRegisterById({
        _id: register.terreno,
        project: { lotes: 1, ofertas: 1 }
      })
  }
    #getLoteLineOfTerreno({ register }) { // eslint-disable-line
    // quando atualizar o lote pode ser que o id do lote mude
    const loteLine = this.#terrenos.form.register?.lotes.find(lote => lote.lote == register.lote)
    return loteLine
  }
    #fillTerrenoInfos({ register, loteLine }) {  // eslint-disable-line
    const lotesMultilinesFields = [
      'matricula',
      'areaIPTU',
      'contribuinte',
      'codlog',
      'testada',
      'link_status',
      'valor',
      'obs'
    ]
    lotesMultilinesFields.forEach(field => { register[field] = loteLine[field] })
  }
  #fillPublicInfos({ register }) { // eslint-disable-line
    this.#fillIPTUsInfos({ register })
    this.#fillITBIsInfos({ register })
    this.form.poligono?.setInFieldMap()
  }
  #fillIPTUsInfos({ register }) { // eslint-disable-line
    const iptuFields = [
      "cep",
      "logradouro",
      "numeroImovel",
      "complemento",
      "areaConstruida",
      "tipoDeUso",
      "anoConstrucao"
    ]
    iptuFields.forEach(field => { register[field] = this.#iptus[field] })
  }
  #fillITBIsInfos({ register }) { // eslint-disable-line
    const transacoes = this.#itbis?.list?.[0]?.data?.map(transacao => {
      return {
        situacaoSql: transacao.situacaoSql,
        data: transacao.data,
        complemento: transacao.complemento,
        natureza: transacao.natureza,
        proporcao: transacao.proporcao,
        valorTransacionado: transacao.valorTransacionado,
        area: transacao.area
      }
    })
    register.transacoes = transacoes
  }
  async #getLoteInfos({ register }) { // eslint-disable-line
    this.#lotes = new LotesDM({})
    await this.#lotes
      .form
      .readRegisterById({
        _id: register.lote,
        project: { sqlc: 1, setor: 1, quadra: 1, lote: 1, condominio: 1 }
      })
  }
  async #getIPTUInfos() { // eslint-disable-line
    this.#iptus = await (new IPTUsDM({})).getIPTU({
      modelClass: true,
      action: 'read/one',
      info: this.#lotes.form.register,
      project: IPTU.projectTerrenosLotes
    })
  }
  async #getITBIInfos() { // eslint-disable-line
    const sql = this.#lotes.form.register.sqlc.slice(0, -2)
    this.#itbis = await (new ITBIsDM({})).getITBIsOfLote({ sql, project: ITBI.projectImoveisForm })
  }
}

class NegociacoesMultilines extends multilines {
  constructor({ form, register, fields, name = 'negociacoes', Logic }) {
    super({ form, register, fields, name, Logic, originClass: NegociacoesMultilines })
  }
  fillInfos({ register, data }) { // eslint-disable-line
    register.negociacoes[0].data = data
    this.valor.calculeNegociacaoValorporm2({ vmodel: register.negociacoes[0] })
  }
}

class NegociacoesValorText extends FieldText {
  #form
  constructor({ form, register, fields, multiline = 'negociacoes', name = 'valor', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: NegociacoesValorText })
    this.#form = form
  }
  keyup({ vmodel }) { this.calculeNegociacaoValorporm2({ vmodel }) }
  calculeNegociacaoValorporm2({ vmodel }) {
    const areaIPTU = jsf.numberIn(this.#form.register.areaIPTU)
    const valorTotal = jsf.numberIn(vmodel.valor)
    const valorporm2 = valorTotal / areaIPTU
    vmodel.valorporm2 = jsf.numberOut(valorporm2, 2)
  }
}

class NegociacoesValorporm2Text extends FieldText {
  #form
  constructor({ form, register, fields, multiline = 'negociacoes', name = 'valorporm2', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: NegociacoesValorporm2Text })
    this.#form = form
  }
  keyup({ vmodel }) { this.calculeNegociacaoValorTotal({ vmodel }) }
  calculeNegociacaoValorTotal({ vmodel }) {
    const areaIPTU = jsf.numberIn(this.#form.register.areaIPTU)
    const valorporm2 = jsf.numberIn(vmodel.valorporm2)
    const valorTotal = areaIPTU * valorporm2
    vmodel.valor = jsf.numberOut(valorTotal, 2)
  }
}

export class LotesFieldMap extends FieldMap { // Class to personalise terreno FieldMap
  #ref
  #form
  #lotes
  #register
  #fields
  #poligono
  #Logic
  #dataId
  constructor({ ref, form, register, fields, name = 'poligono', div, Logic, dataId }) {
    super({
      ref,
      form,
      register,
      fields,
      name,
      field: jsf.getJSONObject({ fields, name: 'poligono' }),
      div,
      Logic,
      originClass: LotesFieldMap
    })
    this.#ref = ref
    this.#form = form
    this.#register = register
    this.#fields = fields
    this.#Logic = Logic
    this.#dataId = dataId
  }
  async centerMap() { super.setMapCenter({ address: 'São Paulo - SP', zoom: 9 }) }
  async setInFieldMap() {
    window.showOverlay()
    this.#lotes = new LotesDM({})
    await this.#lotes
      .form
      .readRegisterById({
        _id: this.#form.register.lote,
        project: { poligono: 1 }
      })
    this.#form.poligono.value = this.#lotes.form.register.poligono
    const _objects = await this.#lotes.getMapObject({ optionsType: 'saved' })
    const objects = _objects.map(object => object.mapObjectParts).flat()
    super.insertObjects({ objects })
    super.fitBounds({ objects, adjustZoom: - 1 })
    this.#calculeAreaAndPerimetro()
    window.hideOverlay()
  }
  #calculeAreaAndPerimetro() { // eslint-disable-line
    let area = 0
    const isPolygon = (objeto) => typeof objeto.getPath == 'function'
    const hasOnlyOnePolygon = () => this.objects.lotes?.filter(objeto => isPolygon(objeto)).length == 1
    this.objects.lotes?.map(object => area += isPolygon(object) ? window.google.maps.geometry.spherical.computeArea(object.getPath()) : 0)
    const perimeterPolygon = this.objects.lotes?.find(object => isPolygon(object))
    const perimeter = perimeterPolygon ? window.google.maps.geometry.spherical.computeLength(perimeterPolygon.getPath()) : 0
    this.#form.register.poligonoArea = jsf.numberOut(area, 2) || ''
    if (this.objects.lotes?.length == 1 && hasOnlyOnePolygon()) { this.#form.register.poligonoPerimetro = jsf.numberOut(perimeter, 2) }
  }
}